import * as _ from "lodash";
import * as React from 'react';
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Checkbox, MenuItemProps} from "semantic-ui-react";
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";
import {ILocalStorageUserProperties, UserDynTableProperty} from "../../services/UserDynTableProperties";
import {
    IVirtualizedTableColumn,
    ILocalColumnSizeSettings,
    IVisibleTableColumnList,
    TData,
    TDataValue,
    ITextExportStatus,
    HeaderFilterType
} from "../../components/Table/VirtualizedTableInterfaces";
import {FilterHandler} from "../../components/Table/dataHandler/FilterHandler";
import {buildComponent} from "../../components/Table/ComponentBuilder";
import {
    AutoSizer,
    GridCellProps,
    Index,
    MultiGrid as ReactVirtualizedGrid
} from "react-virtualized";
import TableFooterActions from "../../components/Table/components/footerComponents/TableFooterActions";
import TablePagination from "../../components/Table/components/footerComponents/pagination/TablePagination";
import {sortModeltypeColumns, TypeFamilyKey, Visible} from "./ModeltypeBasicColumns";
import {
    buildPCCDStatusComponent,
    keepRowSorting,
    PCCDFlag,
    PDiPFlag,
    scrollGridToTop,
    virtualizedTableId
} from "../../components/Table/VirtualizedTableUtils";
import {PCCDFilterEnum, PDiPFilterEnum} from "../../components/Table/VirtualizedTableEnums";
import VirtualizedTableHeaderCell from "../../components/Table/components/headerComponents/virtualizedTableHeaderCell/VirtualizedTableHeaderCell";
import GeneralActions from "../../redux/actions/GeneralActions";
import {compose, Dispatch} from "redux";
import {
    selectClient,
    selectVirtualizedTableReload,
    selectVirtualizedTableRollback,
    selectVirtualizedTableSelectedIdList
} from "../../redux/selectors";
import {IReduxState} from "src/redux/IReduxState";
import HATEOASClient from "src/services/HATEOASClient";
import {OSPGenerationDto} from "src/services/Client";

interface IMapDispatchToProps {
    tableRollBack: (flag: boolean) => void;
    setSelectedIds: (ids: string[]) => void;
}

interface IMapStateToProps {
    dynTableReload: boolean;
    dynTabelRollback: boolean;
    dynTableSelectedIdList: string[];
    client: HATEOASClient;
}

interface IOwnProps {
    columnsData: IVirtualizedTableColumn[];
    data: TData[];
    onChange: (key: string, data: TDataValue, index: number) => void;
    onChangeSelect: (index: number[]) => void;
    allOSP:OSPGenerationDto[];
}

interface ModelTypeBasicTableProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent {
}

interface ModelTypeBasicTableState {
    data: TData[];
    filterValue: {[key: string]: any};
    currentPage: number;
    numberOfItems: number;
    visibleColumns: IVirtualizedTableColumn[];
    columnSizeSetting: ILocalColumnSizeSettings;
    rowVisibleList: IVisibleTableColumnList;
    rowSort: string[];
    rows: IVirtualizedTableColumn[];
}

class ModelTypeBasicTable extends React.Component<ModelTypeBasicTableProps, ModelTypeBasicTableState> {
    numberOfItemsList = [15, 30, 60];
    gridRef: ReactVirtualizedGrid | null;

    private filterHandler: FilterHandler;
    private localStorageKey = "prompt_dynTable";
    private dataForRollBack: TData[];

    private userPropertiesSettings: UserDynTableProperty;

    constructor(props: ModelTypeBasicTableProps) {
        super(props);
        this.filterHandler = new FilterHandler();

        this.state = {
            data: [],
            filterValue: {},
            currentPage: 1,
            numberOfItems: this.numberOfItemsList[0],
            rowVisibleList: {},
            visibleColumns: [],
            columnSizeSetting: {},
            rowSort: [],
            rows: [],
        };

        this.userPropertiesSettings = new UserDynTableProperty(this.localStorageKey + "_ModelTypeBasic", this.props.columnsData);
    }

    componentDidMount() {
        this.setState({rows: this.props.columnsData}, () => {
            const filterValue: {[key: string]: boolean | string} = {};

            let localUserProperties: ILocalStorageUserProperties | null = this.userPropertiesSettings.get();

            if (localUserProperties === null) {
                localUserProperties = this.userPropertiesSettings.create();
                this.userPropertiesSettings.save(localUserProperties);
            }

            this.setState({
                data: this.props.data,
                filterValue: filterValue,
                rowSort: localUserProperties ? localUserProperties.rowSort : [],
                rowVisibleList: localUserProperties ? localUserProperties.rowVisibleList : {},
                columnSizeSetting: localUserProperties ? localUserProperties.columnSizeSetting : {}
            });
        });
    }

    componentDidUpdate(prevProps: ModelTypeBasicTableProps, prevState: ModelTypeBasicTableState) {
        if (prevProps.columnsData !== this.props.columnsData) {
            this.setState(
                {
                    rows: keepRowSorting(this.state.rowSort, this.props.columnsData),
                },
                () => this.setState({
                    visibleColumns: this.state.rows.filter(column => this.state.rowVisibleList[column.key].visible).sort(sortModeltypeColumns)
                })
            );
        }
        if (prevProps.data !== this.props.data) {
            this.setState({data: this.props.data});
        }

        if (this.props.dynTableReload === true && prevProps.dynTableReload === false) {
            this.setState({filterValue: {}});
        }

        let localUserProperties: ILocalStorageUserProperties | null = this.userPropertiesSettings.get();

        if (localUserProperties) {
            if (!_.isEqual(localUserProperties.columnSizeSetting, this.state.columnSizeSetting) ||
                !_.isEqual(localUserProperties.rowVisibleList, this.state.rowVisibleList) ||
                !_.isEqual(localUserProperties.rowSort, this.state.rowSort)) {
                let updatedUserProperties: ILocalStorageUserProperties | null = this.userPropertiesSettings.update(
                    this.state.rows,
                    this.state.columnSizeSetting,
                    this.state.rowVisibleList,
                    this.state.rowSort
                );

                if (updatedUserProperties) {
                    this.setState(
                        {
                            rowSort: updatedUserProperties.rowSort,
                            rowVisibleList: updatedUserProperties.rowVisibleList,
                            columnSizeSetting: updatedUserProperties.columnSizeSetting
                        },
                        () => {
                            this.userPropertiesSettings.save(updatedUserProperties);
                            this.setState({
                                visibleColumns: this.state.rows.filter(column =>
                                    this.state.rowVisibleList[column.key] && this.state.rowVisibleList[column.key].visible).sort(sortModeltypeColumns)
                            });
                        }
                    );
                }
            }
        }

        if (this.props.dynTabelRollback) {
            this.setState({data: this.dataForRollBack});
            this.props.tableRollBack(false);
        }

        if (this.gridRef) {
            this.gridRef.forceUpdate();
            this.gridRef.recomputeGridSize();
        }
    }

    componentWillUnmount() {
        this.props.setSelectedIds([]);
    }

    /**
     * processes the change to the selection array
     * @param checked is the row selected
     * @param rowNumber target rowNumber
     */
    private onChangeRowSelection(checked: boolean, rowId: string) {
        let selectedIdList: string[] = [];

        if (checked) {
            selectedIdList.push(rowId);
        }
        else {
            _.pull(selectedIdList, rowId);
        }
        const indexList = selectedIdList.map((item) => parseInt(item, undefined));
        this.props.setSelectedIds(selectedIdList);
        this.props.onChangeSelect(indexList);
    }

    /**
     * on cell value changed
     */
    private onDataChanged = (key: string, rowNumber: number, newValue: any) => {
        const data = [...this.state.data];
        this.dataForRollBack = _.cloneDeep(data);
        if (!_.isEqual(data[rowNumber][key], newValue)) {
            data[rowNumber][key] = newValue;
            this.setState({data}, () => {
                this.props.onChange(key, newValue, rowNumber);
            });
        }
    }

    private onFilterChange = (newHeaderFilter: HeaderFilterType) => {
        scrollGridToTop();
        this.setState({filterValue: newHeaderFilter, currentPage: 1});
    }

    private filterData(data: TData[]) {
        return this.filterHandler.filterData(data, this.state.filterValue, this.state.rows);
    }

    private handleTableMenuChange = (
        rowVisibleList: any,
        resetHideEmptyRowsAndColumnsFilter?: boolean,
        key?: string,
        clearHeaderFilters?: boolean
    ) => {
        if (clearHeaderFilters) {
            let newFilter = {...this.state.filterValue};
            Object.keys(this.state.filterValue).forEach(keyFilter => {
                if (keyFilter !== PDiPFlag) {
                    newFilter[keyFilter] = "";
                }
            });

            this.onFilterChange(newFilter);
        } else if (key && this.state.filterValue[key]) {
            this.onFilterChange({...this.state.filterValue, [key]: ""});
        }

        this.setState({rowVisibleList}, () => {
            this.setState({
                rowSort: Object.keys(_.pickBy(this.state.rowVisibleList, (item) => item.visible))
            });
        });
    }

    private setNumberOfItems = (e: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) => {
        this.setState(
            {
                numberOfItems: data.value,
                currentPage: 1,
            },
            scrollGridToTop);
    }

    /**
     * Adds the _id property to data
     */
    private appendAdditionalPropertiesToData = () => {
        let data: any[] = [];
        data = this.state.data.map((item, index) => {
            return {
                ...item,
                _id: index.toString(),
            };
        });
        return data;
    }

    /**
     *  Computes the number of visible columns so the Grid knows
     *  how many to render.
     */
    private getColumnCount = (): number => {
        return this.state.visibleColumns.length + 1;
    }

    /**
     *  Returns the width of the cells to the Grid according
     *  to the user settings.
     */
    private getColumnWidth = ({index}: Index): number => {
        if (index === 0) {
            return 70;
        }
        const trueIndex = index - 1;
        const {visibleColumns, columnSizeSetting} = this.state;
        return columnSizeSetting[visibleColumns[trueIndex].key] ? columnSizeSetting[visibleColumns[trueIndex].key].width + 20 : 120;
    }

    /**
     * Returns the height of the row.
     *
     * The header has a fixed height of 150, and the rows 50.
     */
    private getRowHeight = ({index}: Index): number => {
        if (index === 0) {
            return 100;
        }
        return 100;
    }

    /**
     *  Computes the cells for the Grid based on the indexes
     *  passed from the Grid renderer function.
     */
    private renderGridCell = (
        {columnIndex, key, rowIndex, style, parent}: GridCellProps,
        data: any[],
    ): React.ReactNode => {

        if (data.length === 0 && rowIndex === 1) {
            return <div className='grid-empty-row' key={key} style={style} />;
        }
        if (columnIndex === 0 && rowIndex === 0) {
            return (
                <div
                    className='grid-first-column-row grid-border-left grid-border-bottom grid-border-right grid-border-top'
                    key={key}
                    style={style}
                />
            );
        }

        if (rowIndex === 0) {
            return this.renderGridHeader(columnIndex, key, style);
        }

        if (columnIndex === 0) {
            const item = data[rowIndex - 1];
            return (
                <div
                    className={`grid-centered-cell grid-border-left grid-border-bottom grid-border-right ${rowIndex % 2 === 1 ? 'grid-white-row' : 'grid-grey-row'}
                                ${item.rowClass === "" ? '' : 'table-invalid-pdip-first-cell'}`}
                    id={`checkbox-${rowIndex}`}
                    key={key}
                    style={style}
                >
                    <Checkbox
                        slider={true}
                        checked={this.props.dynTableSelectedIdList.findIndex((rowId) => data[rowIndex - 1]._id === rowId) > -1}
                        onChange={(e, v) => {
                            this.onChangeRowSelection(v.checked as boolean, data[rowIndex - 1]._id as string);
                        }}
                    />

                </div>
            );

        }

        return this.renderGridBody(rowIndex, columnIndex, key, style, data);
    }

    /**
     *  Computes the cells of the fixed row in the Grid (Header)
     */
    private renderGridHeader = (columnIndex: number, key: string, style: React.CSSProperties): React.ReactNode => {
        const item = this.state.visibleColumns[columnIndex - 1];

        if (this.state.rowVisibleList[item.key] && !this.state.rowVisibleList[item.key].visible)
            return null;

        return (
            <VirtualizedTableHeaderCell
                t={this.props.t}
                key={key}
                hasDropdown={false}
                visibleColumn={item}
                style={style}
                columnSizeSetting={this.state.columnSizeSetting}
                filterValue={this.state.filterValue}
                setState={(newColumnWidth: ILocalColumnSizeSettings) => this.setState({columnSizeSetting: newColumnWidth})}
                onFilterChange={(filterKey, value) => this.onFilterChange({...this.state.filterValue, [filterKey]: value})}
            />
        );
    }

    /**
     *  Computes the cells of the Grid body
     */
    private renderGridBody = (
        rowIndex: number,
        columnIndex: number,
        keyGrid: string,
        style: React.CSSProperties,
        data: TData[],
    ): React.ReactNode => {

        const item: TData = data[rowIndex - 1];
        let readOnly: boolean = item.isDisabled !== undefined ? item.isDisabled as boolean : false;
        const visibleColumn: IVirtualizedTableColumn = this.state.visibleColumns[columnIndex - 1];
        const key: string = visibleColumn.key;
        const TargetComponent = buildComponent(visibleColumn.rowType);
        const options = visibleColumn.options || {};
        // this is an index, not the real option dto id
        const id: number = parseInt(item._id as string, 10);
        const className = `grid-centered-cell grid-border-bottom grid-border-right
        ${item.rowClass} ${rowIndex % 2 === 1 ? 'grid-white-row' : 'grid-grey-row'}`;

        if (!readOnly && options.readOnly !== null && options.readOnly !== undefined) {
            readOnly = options.readOnly;
        }

        return (
            <div
                className={className}
                key={keyGrid}
                style={style}
            >
                <div style={{ display: "flex", alignItems: "center" }}>
                    {key === 'btyp' && buildPCCDStatusComponent({ textExportDate: item.textExportDate, textExportStatus: item.textExportStatus } as ITextExportStatus)}
                    <div style={{ width: '100%' }}>
                        <TargetComponent
                            t={this.props.t}
                            rowIndex={rowIndex}
                            language={this.props.i18n.language}
                            uglyMode={false}
                            value={item[key]}
                            onChange={(newValue) => this.onDataChanged(key, id, newValue)}
                            readOnly={readOnly}
                            width={this.state.columnSizeSetting[TypeFamilyKey].width}
                            toggle={key === Visible}
                            item={item}
                            client={this.props.client}
                            allOSP={this.props.allOSP}
                        />
                    </div>
                </div>
            </div>
        );
    }

    public render() {
        let data: any[] = this.appendAdditionalPropertiesToData();
        let filteredData = this.filterData(data);
        data = filteredData.slice((this.state.currentPage - 1) * this.state.numberOfItems, this.state.currentPage * this.state.numberOfItems);

        return (
            <div className={"position--relative"}  data-cy="derivate_table">
                {/* ========== REACT VIRTUALIZED GRID ============= */}
                <div id='grid-container'>
                    <AutoSizer disableHeight={true}>
                        {({width}) => (
                            <React.Fragment>
                                {/* This div forces the header to be in sync with the body when scrolling
                              Also, displays the message for 'no data'*/}
                                <div
                                    className="grid-overlay-div"
                                >
                                    {data.length === 0 &&
                                        <div>{this.props.t("NO_DATA")}</div>
                                    }
                                </div>
                                <ReactVirtualizedGrid
                                    id={virtualizedTableId}
                                    ref={(ref) => this.gridRef = ref}
                                    rowCount={data.length > 0 ? data.length + 1 : 2}
                                    rowHeight={this.getRowHeight}
                                    width={width}
                                    height={window.innerHeight - 176}
                                    columnCount={this.getColumnCount()}
                                    estimatedColumnSize={150}
                                    cellRenderer={(props: GridCellProps) => this.renderGridCell(props, data)}
                                    columnWidth={(index) => this.getColumnWidth(index)}
                                    fixedRowCount={1}
                                    overscanRowCount={5}
                                    overscanColumnCount={5}
                                />
                            </React.Fragment>
                        )}
                    </AutoSizer>
                </div>
                {/* ========== PAGINATION TABS ============= */}
                <div className='virtualized-table-pagination-footer' >
                    <TableFooterActions
                        t={this.props.t}
                        visibleColumns={this.state.rowVisibleList}
                        onChange={this.handleTableMenuChange}
                        pdipFilterValue={(this.state.filterValue[PDiPFlag] || PDiPFilterEnum.SHOW_ALL) as PDiPFilterEnum}
                        pccdFilterValue={(this.state.filterValue[PCCDFlag] || PCCDFilterEnum.SHOW_ALL) as PCCDFilterEnum}
                        onFilterChange={(key, val) => this.onFilterChange({...this.state.filterValue, [key]: val})}
                        columnLabels={this.props.columnsData}
                    />
                    <TablePagination
                        numberOfItems={this.state.numberOfItems}
                        setNumberOfItems={this.setNumberOfItems}
                        dataLength={this.state.data.length}
                        filteredDataLength={filteredData.length}
                        hasScrollBtn={true}
                        customNoOfItems={this.numberOfItemsList}
                        t={this.props.t}
                        currentPage={this.state.currentPage}
                        onPageChange={(e, c) =>
                            this.setState(
                                {currentPage: c.activePage as number},
                                scrollGridToTop
                            )}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    dynTableReload: selectVirtualizedTableReload(state),
    dynTabelRollback: selectVirtualizedTableRollback(state),
    dynTableSelectedIdList: selectVirtualizedTableSelectedIdList(state),
    client: selectClient(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    tableRollBack: (flag: boolean) => dispatch(GeneralActions.DynTableRollBack(flag)),
    setSelectedIds: (ids: string[]) => dispatch(GeneralActions.DynTableSetSelectedIdList(ids)),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["COLUMN_FACTORY", "GLOBAL", "EXPORT"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(ModelTypeBasicTable);



// WEBPACK FOOTER //
// ./src/views/ModeltypeBasicView/ModelTypeBasicTable.tsx